import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';
import { fonts } from '../theme';

const TABS = [
  { id: 'home', label: 'Home', icon: 'home', path: '/' },
  { id: 'about', label: 'About', icon: 'star', path: '/about' },
  { id: 'book', label: 'Book', icon: 'calendar', path: '/book' },
  { id: 'services', label: 'Care', icon: 'spine', path: '/services' },
  { id: 'contact', label: 'Contact', icon: 'mail', path: '/contact' },
];

export default function TabBar({ t }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = TABS.find(tab => tab.path === pathname)?.id
    || (pathname === '/' ? 'home' : '');

  return (
    <div style={{
      position: 'absolute', left: 0, right: 0, bottom: 0,
      paddingBottom: 30, paddingTop: 10, paddingLeft: 12, paddingRight: 12,
      background: 'rgba(246,243,236,0.85)',
      backdropFilter: 'blur(20px) saturate(180%)',
      WebkitBackdropFilter: 'blur(20px) saturate(180%)',
      borderTop: `0.5px solid ${t.hair}`,
      display: 'flex', justifyContent: 'space-around', alignItems: 'center',
      zIndex: 20,
    }}>
      {TABS.map(tab => {
        const on = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            style={{
              appearance: 'none', border: 'none', background: 'transparent', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
              padding: '6px 8px', borderRadius: 8,
              color: on ? t.ink : t.muted,
              fontFamily: fonts.sans, fontSize: 9.5, fontWeight: on ? 600 : 500,
              letterSpacing: '0.02em',
            }}>
            <Icon name={tab.icon} size={20} sw={on ? 1.9 : 1.5} />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
